import styled from 'styled-components'
import { margin } from '@styled-system/space'
import { themeGet } from '@styled-system/theme-get'

import BackgroundGlyph from 'Assets/Svg/background.svg'

export const Container = styled.div.attrs({
  as: 'section',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #ecc4c1;
  overflow-y: auto;
`

export const BackgroundImage = styled(BackgroundGlyph)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
`

export const Info = styled.div`
  position: absolute;
  z-index: 1;
  top: ${themeGet('space.6')}px;
  left: ${themeGet('space.6')}px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Name = styled.div`
  font-size: 24px;
  line-height: normal;
  font-weight: bold;
  color: ${themeGet('colors.white')};

  ${margin}
`

export const Text = styled.div`
  max-width: 420px;
  font-size: 14px;
  color: ${themeGet('colors.bg.primary')};
`

export const Content = styled.div`
  display: flex;
  z-index: 1;
  position: relative;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  width: 480px;
  min-height: 480px;
  padding: ${themeGet('space.4')}px ${themeGet('space.6')}px;
  background-color: ${themeGet('colors.white')};
  border-radius: 24px;
`

export const Copyright = styled.div`
  font-size: 12px;
  line-height: normal;
  color: ${themeGet('colors.font.secondary')};
`
